<template>
  <div class="p-4">
    <div class="bg-red-100 rounded-md px-2 py-1">{{errorMessage}}</div>
  </div>
</template>

<script>
// PortalError.vue script section
export default {
  props: {
    errorType: {
      type: String,
      default: 'generic'
    },
    requestedEntityId: {
      type: Number,
      default: null
    }
  },
  computed: {
    errorMessage() {
      switch(this.errorType) {
      case 'practice_access_denied':
        return `You don't have access to this entity's portal (id=${this.requestedEntityId}). Please contact your account
        administrator for access.`;
      default:
        return 'An error occurred while accessing the portal';
      }
    }
  }
}

</script>
